// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".moon-phase-icon{position:relative;border-radius:50%;overflow:hidden;min-height:30px;max-height:30px;height:30px;min-width:30px;max-width:30px;width:30px}.moon-phase-icon--northern{transform:rotateY(180deg)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
